import { enableMapSet } from "immer";
import { isStageLocalhost } from "src/app/utils/storebrand-staging";
import { Log } from "./app/utils/log";
import { Monitoring } from "./app/utils/monitoring";
import { environment } from "./environments/environment";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "src/app/app.config";
import { setAppInjector } from "src/app/injector";

// FeatureToggleService stores overrides in a Map and mutates it through
// immer's produce(). immer 10 requires the MapSet plugin to be registered
// explicitly before any Map/Set draft is created.
enableMapSet();

Log.setLogLevel(environment.logLevel);

const bootstrap = (): Promise<void> =>
  bootstrapApplication(AppComponent, appConfig)
    .then((appRef) => setAppInjector(appRef.injector))
    .catch((error) => {
      console.log("Error during Angular bootstrapping process", error);
      // Report to Datadog from inside the catch: a separate outer `.catch` never fires because
      // this handler resolves the promise. Note that failures before AppComponent's constructor
      // runs (where DatadogService.init() configures the SDK) can only be console-logged.
      Monitoring.error(error, { ignore: isStageLocalhost() });
    });

bootstrap();
